module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "quote-slider"
  }, [_c('cmp-carousel', {
    attrs: {
      "facet": "quotes",
      "items": _vm.content.quotes,
      "show-arrows": false
    },
    scopedSlots: _vm._u([{
      key: "item",
      fn: function(props) {
        return [_c('div', {
          staticClass: "quote-slider--item"
        }, [_c('blockquote', {
          staticClass: "quote-slider--quote"
        }, [_c('span', {
          domProps: {
            "textContent": _vm._s(props.item.quote)
          }
        })]), _vm._v(" "), _c('span', {
          staticClass: "quote-slider--author",
          domProps: {
            "textContent": _vm._s(props.item.author)
          }
        })])]
      }
    }])
  })], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-9390cecc", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-9390cecc","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./sib-website/assets/src/js/app/vue/components/cms-plugins/quote-slider/index.vue
// module id = 569
// module chunks = 7